// sbs story
export const OUR_STORY = 'Our Story';

export const STORY_DESCRIPTION =
  'Millions of consumers overpay for financing and insurance every year leaving families struggling to make ends meet. CashClever was founded to empower consumers with the most informed financial decisions and bring greater prosperity to the people.';

// sbs mission
export const OUR_MISSION = 'Our Mission';

export const MISSION_DESCRIPTION =
  'Empower consumers with the best financial decisions with a commitment to delivering transparency, trust and exceptional customer service';

export const JOIN_OUR_LENDER_NETWORK = 'Join Our Lender Network';

// sbs vision
export const OUR_VISION = 'Our Vision';

export const VISION_DESCRIPTION =
  'At CashClever, we aspire to put money back into the hands of the consumers and unlock the potential for broader economic growth and individual prosperity. When people have greater financial freedom, they are empowered to spend, invest, and save in ways that fuel demand for goods and services.';
